import { IUserMilestone } from "@faire/web-api--source/indigofair/data/IUserMilestone";

// Type guards. Milestone types are strings, so there is no way to tell the
// difference between them at runtime without explicitly passing in a flag.

export const getIsBrandMilestone = (
  isBrandMilestone: boolean,
  _milestoneType:
    | IUserMilestone.BrandMilestone
    | IUserMilestone.RetailerMilestone
): _milestoneType is IUserMilestone.BrandMilestone => {
  return isBrandMilestone;
};

export const getIsRetailerMilestone = (
  isBrandMilestone: boolean,
  _milestoneType:
    | IUserMilestone.BrandMilestone
    | IUserMilestone.RetailerMilestone
): _milestoneType is IUserMilestone.RetailerMilestone => {
  return !isBrandMilestone;
};
